<template>
  <div class="nav-container">
    <div class="logo-header cursor-pointer">
      <router-link to="/" class="logo" />
    </div>
    <q-badge v-if="url.indexOf('staging') > -1">Staging</q-badge>

    <div v-bind:class="{ show: isExpanded }">
      <div class="menu-buttons">
        <Slide right class="burger-menu">
          <div v-if="!isLoggedIn">
            <router-link :to="{ name: 'Login' }">
              <q-btn
                outline
                color="primary"
                label="Login"
                class="burgermenu-button full-width"
              >
              </q-btn>
            </router-link>
          </div>

          <router-link
            :to="{ name: 'TagTab', params: { tab: 'Audience' } }"
            v-if="isLoggedIn && isSuperAdmin"
          >
            <q-btn
              outline
              color="primary"
              label="Tags"
              class="burgermenu-button full-width"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'SchemesSearchPage' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Schemes"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'News' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="News"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'Organisations' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Organisations"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link
            :to="{ name: 'News' }"
            class="navmenu-link"
            v-if="isLoggedIn"
          >
            <q-btn outline color="primary" label="News"> </q-btn>
          </router-link>
          <router-link :to="{ name: 'CustomersGrid' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Customers"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>
          <router-link :to="{ name: 'UsersGrid' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Users"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <router-link :to="{ name: 'AccountManagersGrid' }" v-if="isLoggedIn">
            <q-btn
              outline
              color="primary"
              label="Account managers"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>
          <q-btn-dropdown
            v-if="isLoggedIn"
            outline
            color="primary"
            label="VisualPing"
            class="burgermenu-button full-width"
            no-caps
          >
            <q-list>
              <q-item
                clickable
                v-close-popup
                :to="{ name: 'VisualPingLinks' }"
                @click="collapse"
              >
                <q-item-section>Links</q-item-section>
              </q-item>
              <q-item
                clickable
                v-close-popup
                :to="{ name: 'VisualPingData' }"
                @click="collapse"
              >
                <q-item-section>Data</q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
          <router-link
            :to="{ name: 'EditEmailTemplates' }"
            v-if="isLoggedIn && isSuperAdmin"
          >
            <q-btn
              outline
              color="primary"
              label="Email templates"
              class="burgermenu-button"
            >
            </q-btn>
          </router-link>

          <q-btn
            v-if="isLoggedIn"
            outline
            color="primary"
            label="Logout"
            class="burgermenu-button full-width"
            @click="logout"
          >
          </q-btn>
        </Slide>

        <div>
          <router-link :to="{ name: 'Login' }" class="navmenu-link">
            <q-btn
              label="Login"
              v-if="!isLoggedIn"
              flat
              color="white"
              no-caps
              class="navmenu-link q-ml-sm"
            >
            </q-btn>
          </router-link>
        </div>

        <router-link :to="{ name: 'GeneralStats' }" class="navmenu-link">
          <q-btn
            :class="isUnderlined('stats')"
            label="Stats"
            v-if="isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>

        <router-link
          v-if="isSuperAdmin || canSetAIAssistantVisibility"
          :to="{ name: 'AISettings' }"
          class="navmenu-link"
        >
          <q-btn
            :class="isUnderlined('ai-settings')"
            label="AI Settings"
            v-if="isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'GlobalSettings' }" class="navmenu-link">
          <q-btn
            :class="isUnderlined('global-settings')"
            label="Global settings"
            v-if="isLoggedIn"
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
          >
          </q-btn>
        </router-link>
        <router-link
          v-if="isSuperAdmin"
          :to="{ name: 'TagTab', params: { tab: 'Audience' } }"
          class="navmenu-link"
        >
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('tags')"
            label="Tags"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'SchemesSearchPage' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('schemes')"
            label="Schemes"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'News' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('news')"
            label="News"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'Organisations' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('organisations')"
            label="Organisations"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>
        <router-link :to="{ name: 'CustomersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('customers')"
            label="Customers"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'UsersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('users')"
            label="Users"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>

        <router-link :to="{ name: 'AccountManagersGrid' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('account-managers')"
            label="Account managers"
            v-if="isLoggedIn"
          >
          </q-btn>
        </router-link>
        <q-btn-dropdown
          flat
          color="white"
          no-caps
          class="navmenu-link q-ml-sm"
          :class="isUnderlined('visualping')"
          label="VisualPing"
          v-if="isLoggedIn"
        >
          <q-list>
            <q-item clickable v-close-popup :to="{ name: 'VisualPingLinks' }">
              <q-item-section>Links</q-item-section>
            </q-item>
            <q-item clickable v-close-popup :to="{ name: 'VisualPingData' }">
              <q-item-section>Data</q-item-section>
            </q-item>
          </q-list>
        </q-btn-dropdown>

        <router-link :to="{ name: 'EditEmailTemplates' }" class="navmenu-link">
          <q-btn
            flat
            color="white"
            no-caps
            class="navmenu-link q-ml-sm"
            :class="isUnderlined('edit-templates')"
            label="Email templates"
            v-if="isLoggedIn && isSuperAdmin"
          >
          </q-btn>
        </router-link>

        <div class="row middle-section" v-if="isLoggedIn">
          <div
            class="notification-container"
            :class="
              unseenNotificationsList.length > 0 ? 'has-unseen-notifs' : ''
            "
          >
            <i
              ref="bellIcon"
              class="las la-2x la-bell bell-btn"
              @click="togglePopover()"
            ></i>
            <span class="icon-button__badge bold-font">
              {{ unseenNotificationsList.length }}
            </span>
          </div>
          <DxPopover
            :target="bellIcon"
            :visible="isPopoverVisible"
            hide-event="outsideClick"
            position="bottom"
            class="popover"
          >
            <template #content>
              <DxTabPanel
                item-template="tabPanelItem"
                :animation-enabled="true"
                :swipe-enabled="true"
                :items="tabs"
                :tabs-position="'top'"
                :styling-mode="'secondary'"
                :icon-position="'top'"
              >
                <template #tabPanelItem="{ data }">
                  <NotificationsList
                    :data="data.notifications"
                    :markNotificationAsSeen="markNotificationAsSeen"
                    :deleteNotification="deleteNotification"
                  />
                </template>
              </DxTabPanel>
            </template>
          </DxPopover>
        </div>

        <q-btn
          flat
          color="white"
          no-caps
          class="navmenu-link q-ml-sm"
          :class="isUnderlined('logout')"
          label="Logout"
          v-if="isLoggedIn"
          @click="logout"
        >
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import axios from "axios";
import * as signalR from "@microsoft/signalr";
import { Slide } from "vue3-burger-menu";
import store from "../store/index.js";
import { useRoute, useRouter } from "vue-router";
import { ref, computed, onUnmounted, watch } from "vue";
import authService from "../services/auth.service.js";
import notificationsService from "../services/notifications.service.js";
import axiosUrl from "../services/axios.service.js";
import { DxPopover } from "devextreme-vue/popover";
import DxTabPanel from "devextreme-vue/tab-panel";
import NotificationsList from "../components/notifications-components/NotificationsList.vue";

const API_URL = axiosUrl.getAxiosUrl();
const hubEventName = "ReceiveAiSchemeCreationNotification";
const route = useRoute();
const router = useRouter();

const isExpanded = ref(false);
const isPopoverVisible = ref(false);
const bellIcon = ref(null);
const connection = ref(null);
const url = window.location.href;

const isLoggedIn = computed(() => store.state.auth.isLoggedIn);
const isSuperAdmin = computed(() => !!store.state.auth.authUser?.isSuperAdmin);

const seenNotificationsList = computed(
  () => store.state.notifications.schemeCreationNotifications.seenNotifications
);

const unseenNotificationsList = computed(
  () =>
    store.state.notifications.schemeCreationNotifications.unseenNotifications
);

const tabs = computed(() => [
  {
    title: "Unseen notifications",
    component: NotificationsList,
    notifications: unseenNotificationsList.value
  },
  {
    title: "Seen notifications",
    component: NotificationsList,
    notifications: seenNotificationsList.value
  }
]);

const togglePopover = () => {
  isPopoverVisible.value = !isPopoverVisible.value;
};

const triggerShake = () => {
  if (bellIcon.value) {
    bellIcon.value.classList.add("shake");
    setTimeout(() => bellIcon.value.classList.remove("shake"), 800);
  }
};

const collapse = () => {
  isExpanded.value = false;
};

const logout = async () => {
  await authService.logout(true);
  router.push({ name: "Login" });
};

const isUnderlined = buttonRoute => {
  if (route.fullPath.includes(buttonRoute)) {
    return "btn-nav-underlined";
  }

  return "";
};

const handleNotificationsError = error => {
  const errorMessage = error?.response?.data ?? "Unable to load notifications.";
  store.commit("notifications/updateModalError", errorMessage);
  store.commit("notifications/enableModalError");
};

const notificationsApiBaseUrl = process.env.VUE_APP_API_BASE_URL;

const loadNotifications = async ({ triggerBell = false } = {}) => {
  const previousUnseenCount = unseenNotificationsList.value.length;

  try {
    const response = await axios.get(
      `${API_URL}notifications/getAllNotifications`
    );
    store.commit(
      "notifications/updateSchemeCreationNotifications",
      response.data
    );

    if (
      triggerBell &&
      response.data?.unseenNotifications?.length > previousUnseenCount
    ) {
      triggerShake();
    }
  } catch (error) {
    handleNotificationsError(error);
  }
};

const startNotificationsHub = async () => {
  if (!isLoggedIn.value || connection.value) {
    return;
  }
  connection.value = new signalR.HubConnectionBuilder()
    .withUrl(`${notificationsApiBaseUrl}/aiSchemeCreationNotificationsHub`)
    .configureLogging(signalR.LogLevel.Information)
    .withAutomaticReconnect()
    .build();

  try {
    await connection.value.start();
  } catch (error) {
    console.error("Error establishing SignalR connection:", error);
  }

  connection.value.on(hubEventName, async () => {
    await loadNotifications({ triggerBell: true });
  });
};

const stopNotificationsHub = async () => {
  if (!connection.value) {
    return;
  }

  connection.value.off(hubEventName);
  await connection.value.stop();
  connection.value = null;
};

const markNotificationAsSeen = async notificationId => {
  await notificationsService.markNotificationAsSeen(notificationId);
  await loadNotifications();
};

const deleteNotification = async notificationId => {
  await notificationsService.deleteNotification(notificationId);
  await loadNotifications();
};

watch(
  isLoggedIn,
  async loggedIn => {
    if (!loggedIn) {
      await stopNotificationsHub();
      return;
    }

    await loadNotifications();
    await startNotificationsHub();
  },
  { immediate: true }
);

onUnmounted(async () => {
  await stopNotificationsHub();
});
</script>

<style scoped lang="scss">
.has-unseen-notifs {
  > .icon-button__badge {
    color: white;
    background-color: red !important;
  }
}

.icon-button__badge {
  position: absolute;
  top: 1px;
  right: 0px;
  left: 15px;
  width: 20px;
  height: 20px;
  background: white;
  color: #25408f !important;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

@media screen and (min-width: 1744px) {
  .icon-button__badge {
    top: -10px !important;
  }
}

.notification-container {
  position: relative;
}

.popover {
  position: absolute !important;
  z-index: 1000;
  width: 340px;
  left: 50%;
  transform: translateX(-50%);
}

.bell-btn {
  transition: transform 0.2s ease-in-out;
  color: white;
}
.bell-btn.shake {
  animation: shake 0.5s;
}

@keyframes shake {
  0%,
  100% {
    transform: rotate(0);
  }
  20%,
  60% {
    transform: rotate(-15deg);
  }
  40%,
  80% {
    transform: rotate(15deg);
  }
}

.middle-section {
  width: max-content;
  display: flex;
  .notification-container {
    display: flex;
    width: min-content;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
